import { render, staticRenderFns } from "./Noteneingabeliste.vue?vue&type=template&id=67665f54"
import script from "./Noteneingabeliste.vue?vue&type=script&lang=js"
export * from "./Noteneingabeliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports